import React, { SyntheticEvent, useContext } from 'react'
import styled from 'styled-components'
import CreationToolUploadField from '../../../types/upload-field'
import { UploadFieldBlock } from '../../blocks'
import Instructions from '../field-instructions'
import Title from '../field-title'
import { CreationToolUploadContext } from '../manager'

const Container = styled(UploadFieldBlock as any)`
    grid-column: span 4;
`

type Props = {
    className?: string
    field: CreationToolUploadField
}

const CreationUploadSourceURLField = ({ className, field }: Props) => {
    const { sourceUrl, setSourceUrl } = useContext(CreationToolUploadContext)
    const placeholder = CreationToolUploadField.description(field)
    const maxLength = CreationToolUploadField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLInputElement, InputEvent>) => {
        setSourceUrl(e.currentTarget.value || '')
    }

    return (
        <Container className={className}>
            <Title field={field} />
            <input
                {...{
                    defaultValue: sourceUrl,
                    type: 'url',
                    placeholder,
                    maxLength: maxLength || undefined,
                    onInput,
                }}
            />
            <Instructions field={field} />
        </Container>
    )
}

export default CreationUploadSourceURLField
